import { KtorHttpEngine1d787w9ug90jw as KtorHttpEngine } from './http/KtorHttpEngine.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KtorWebSocketEngine2cbfnq8i807su as KtorWebSocketEngine } from './ws/KtorWebSocketEngine.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ktorClient(_this__u8e3s4, httpClient) {
  // Inline function 'kotlin.apply' call
  _this__u8e3s4.j65(KtorHttpEngine().f6f(httpClient));
  _this__u8e3s4.q65(KtorWebSocketEngine().k6f(httpClient));
  return _this__u8e3s4;
}
//region block: exports
export {
  ktorClient as ktorClient27akr7bvktwel,
};
//endregion

//# sourceMappingURL=KtorExtensions.mjs.map
